'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _getMeetingsLinkUrl = require('conversations-schema/responders/operators/getMeetingsLinkUrl');

var _getMeetingsLinkUrl2 = _interopRequireDefault(_getMeetingsLinkUrl);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  assignedResponder: (0, _RecordPropType2.default)('Responder'),
  clickedMeetingsLink: _react.PropTypes.func.isRequired,
  widgetData: (0, _RecordPropType2.default)('WidgetData')
};

var MeetingsLinkButton = function (_Component) {
  _inherits(MeetingsLinkButton, _Component);

  function MeetingsLinkButton(props) {
    _classCallCheck(this, MeetingsLinkButton);

    var _this = _possibleConstructorReturn(this, (MeetingsLinkButton.__proto__ || Object.getPrototypeOf(MeetingsLinkButton)).call(this, props));

    _this.handleOnClick = _this.handleOnClick.bind(_this);
    return _this;
  }

  _createClass(MeetingsLinkButton, [{
    key: 'handleOnClick',
    value: function handleOnClick() {
      var _props = this.props,
          clickedMeetingsLink = _props.clickedMeetingsLink,
          assignedResponder = _props.assignedResponder;


      var meetingsLinkUrl = (0, _getMeetingsLinkUrl2.default)(assignedResponder);

      window.open(meetingsLinkUrl + '?fromMessages=true', '_blank');

      clickedMeetingsLink();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          assignedResponder = _props2.assignedResponder,
          _props2$widgetData$co = _props2.widgetData.coloring,
          accentColor = _props2$widgetData$co.accentColor,
          useDefaultColor = _props2$widgetData$co.useDefaultColor;


      if (!assignedResponder || !(0, _getMeetingsLinkUrl2.default)(assignedResponder)) {
        return null;
      }

      var linkColor = !useDefaultColor ? accentColor : null;

      return _react2.default.createElement(
        'div',
        { className: 'widget-meetings-link-button-wrapper' },
        _react2.default.createElement(
          _UIButton2.default,
          {
            use: 'link',
            className: 'widget-meetings-link-button text-center',
            style: { color: linkColor },
            onClick: this.handleOnClick
          },
          _react2.default.createElement(_UIIcon2.default, { name: 'date', style: { color: linkColor } }),
          _react2.default.createElement(_FormattedMessage2.default, { message: 'conversations-visitor-ui.default.meetingsLinkText' })
        )
      );
    }
  }]);

  return MeetingsLinkButton;
}(_react.Component);

MeetingsLinkButton.displayName = 'MeetingsLinkButton';

MeetingsLinkButton.propTypes = propTypes;

exports.default = MeetingsLinkButton;
module.exports = exports['default'];